import React from 'react';
import classNames from 'classnames';
import { Check } from '@saleshandy/icons';

export enum PhoneNumberPurchaseStep {
  SelectNumber = 'select-number',
  ContactDetails = 'contact-details',
}

export type TabConfig = {
  key: PhoneNumberPurchaseStep;
  label: string;
  isCompleted?: boolean;
};

export const TabLabel: React.FC<{
  label: string;
  isActive: boolean;
  isCompleted?: boolean;
}> = ({ label, isActive, isCompleted }) => {
  const labelTextClassName = classNames(['label-text', { active: isActive }]);

  return (
    <div className="purchase-phone-number__tabs--item--label">
      {isCompleted ? (
        <div className="step-complete d-flex justify-content-center align-items-center">
          <Check width={14} height={14} />
        </div>
      ) : (
        <div className={`step-incomplete ${isActive ? 'active' : ''}`} />
      )}
      <span className={labelTextClassName}>{label}</span>
    </div>
  );
};

export const PurchasePhoneNumberTabs: React.FC<{
  tab: TabConfig;
  activeKey: PhoneNumberPurchaseStep;
}> = ({ tab, activeKey }) => (
  <div className="purchase-phone-number__tabs--item">
    <TabLabel
      label={tab.label}
      isActive={tab.key === activeKey}
      isCompleted={tab.isCompleted}
    />
  </div>
);

